import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const MatchScheduleButton = ({ onClick, disabled = false }) => {
  const { t } = useTranslation();
  return (
    <StyledButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={
        disabled
          ? t('teamDashboardPage.matchScheduleButtonDisabledTitle')
          : t('teamDashboardPage.matchScheduleButtonTitle')
      }
    >
      📅 {t('teamDashboardPage.matchScheduleButton')}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.35);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(13, 148, 136, 0.45);
    filter: brightness(1.05);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 13px;
    gap: 4px;
  }
`;

export default MatchScheduleButton;
